<template>
  <div class="list">
    <div class="items">
      <div class="item" v-for="(v, k) in meiLists" :key="k" @click="redTo(k)">
        <div v-if="v.pic">
          <div v-if="v.pic.status == 1">
            <img
              :src="v.pic.meiimage"
              alt=""
              class="photo"
              @click.stop="previewImage(v.pic.meiimage)"
            />
          </div>
          <div v-else>
            <img :src="v.pic.meiimage" alt="" class="photo" />
            <div class="tip">
              <div class="title">
                {{ v.title }}
              </div>
              <div class="desc">审核不过，点我重新上传</div>
            </div>
          </div>
        </div>
        <div class="tip" v-else>
          <div class="title">
            {{ v.title }}
          </div>
          <div class="desc">
            {{ v.desc }}
          </div>
        </div>
      </div>
    </div>

    <div class="btn start">
      <router-link to="upload">
        <img
          src="https://i.tmuyun.com/webpic/W0202204/W020220401/W020220401548706345999.png"
        />
      </router-link>
    </div>

    <van-overlay :show="showTitle" @click="showTitle = false">
      <div class="title-modal">
        <img
          src="https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554725374364.png"
          alt=""
        />

        <div class="back-btn">
          <img
            src="https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554730903045.png"
            alt=""
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { ImagePreview, Overlay } from "vant";
import { myJfwmPic } from "@/api/jfwm";

export default {
  name: "list",
  data() {
    return {
      meiLists: [],
      lists: [
        { title: "爱国爱家美", desc: "上传家庭成员与国旗、党徽等合影的照片" },
        {
          title: "孝老爱亲美",
          desc: "上传与家中老人、小孩的合影照片或全家福照片",
        },
        { title: "邻里和谐美", desc: "上传与邻居的合影照片" },
        { title: "热心奉献美", desc: "上传参与志愿服务、公益活动的照片" },
      ],
      showTitle: false,
    };
  },
  mounted() {
    myJfwmPic().then((res) => {
      const lists = res.data.lists;
      // console.log(lists);
      let pass = 0;

      lists.forEach((vv, kk) => {
        if (vv.status == 1) {
          pass++;
        }
      });

      if (pass >= 4) {
        this.showTitle = true;
      }

      this.lists.forEach((v, k) => {
        lists.forEach((vv, kk) => {
          if (v.title == vv.meilist_text) {
            v.pic = vv;
          }
        });
      });
      // console.log(this.lists);
      this.meiLists = this.lists;
    });
  },
  methods: {
    previewImage(url) {
      ImagePreview({
        images: [url],
      });
    },
    redTo(index) {
      // console.log(title);
      this.$router.push("/jfwm/upload/" + index);
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  .items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      // flex: 1;
      box-sizing: border-box;
      height: 20vh;
      background-image: url("https://i.tmuyun.com/webpic/W0202203/W020220328/W020220328554723278809.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 50%;
      position: relative;
      .photo {
        position: absolute;
        width: 43vw;
        height: 82%;
        left: 50%;
        margin-left: -21.5vw;
        top: 9%;
        border-radius: 10px;
        object-fit: cover;
      }
      .tip {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.6);
        width: 43vw;
        height: 82%;
        left: 50%;
        margin-left: -21.5vw;
        top: 9%;
        border-radius: 10px;
        text-align: center;
        .title {
          font-weight: bold;
          margin-bottom: 10px;
        }
        .desc {
          font-size: 12px;
        }
      }
    }
  }

  .start {
    width: 40vw;
    margin: 10px auto;
    img {
      width: 100%;
    }
  }

  .title-modal {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 80vw;
    margin: auto;
    img {
      width: 100%;
    }
    .back-btn {
      width: 40vw;
      margin-top: 20%;
    }
  }
}
</style>